import React from 'react'
import { Column } from '@sencha/ext-modern'

import { renderColumn } from '..'

const render = (
	{
		key, _columns: text, items = [], filter, filterProp, filterChoices, onFilterChange, sortable, menuDisabled, dataIndex, align = 'center',
		handleEdit, handleBatchEdit, minWidth, flex/* , edit, ...rest */
	},
	that, forViewModel, checkGridData
) => {
	// console.log('columns', handleEdit, rest)
	// 20240227 add flex, 待观后效
	return <Column {...{ key, text, align, sortable, menuDisabled, minWidth, flex/* ...rest, flex: undefined  */ }}>
		{items.map((column, index) => (
			// console.log('columns sub:', column),
			renderColumn(
				{ filter, ...column, filterProp, filterChoices, onFilterChange, sortable, menuDisabled, handleEdit, handleBatchEdit },
				`${key}_${index}`, that, forViewModel, checkGridData
			)
		))}
	</Column>
}

export default render

// renderColumn({
// 	filter: onSearch && searchMode & 2 ? [] : undefined,
// 	...column,
// 	filterProp: me.filter, filterChoices: me.filterChoices, onFilterChange: trySearch,
// 	handleEdit,
// 	...sortableProps
// }, key, that))}
